// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__2cVaX","footerInner":"style_footerInner__lU_He","logo":"style_logo__3EEXY"};